module.exports = __webpack_public_path__ + "static/media/vaccine.a83e24dd.png";